import React from "react";
import { useSelector } from "react-redux";
const CopyRight = () =>{
    const items =  useSelector((state) => state.userDetailsData.LoginDetails);
    const NavigatOrpine = () => { 
        if(items?.userTypeId !== 4){
            window.open("https://www.orpine.com/", "_blank");} };
    return(
        <div className="dflex JSBetween COpyright-Instructions">
        <div>Designed and developed by <b onClick={NavigatOrpine} style={{ cursor: "pointer" }} >Orpine</b></div>
        <div>© Copyright &nbsp;<b>  NCP</b>. All Rights Reserved </div>
    </div>
    )
}
export default CopyRight;